<template>
	<div id="">
		<div v-if="isshow" class="headerbox">
			<div class="headerlist container">
				<img class="logo" src="../assets/images/logo.png" alt="双沟酒业"/>
				<div class="tablist">
					<router-link to="/">
						<div class="tabmod " :class="pageind1 == 0 ? 'active' : ''" style="width: 74px;"><div style="position: relative;width: 36px;">首页<em></em></div></div>
					</router-link>
					<router-link v-for="(item,index) in catelist" :key="index" class="navtab" :to="{path:item.linkContent,query: {type: '',index:index}}">
						<div class="tabmod" :class="pageind1 == index+1 ? 'active' : ''"><div class="tabwordwidth">{{item.title}}<em></em></div></div>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item" v-for="(items,ind) in item.childMenu" :key="ind">
									<div class="nav-tit">
										<router-link class="nav-link" :to="{path:item.linkContent,query: {type: items.code,ind:ind}}">{{items.title}}</router-link>
									</div>
								</li>
								<!-- <li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">企业架构</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">领导风采</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">发展历程</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">文化理念</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">企业荣誉</router-link></div></li> -->
							</ul>
						</div>
					</router-link>
					<!-- <router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/news',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 2 ? 'active' : ''"><div class="tabwordwidth">动态资讯<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">双沟新闻</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">媒体报道</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">双沟酒讯</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">行业动态</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">视频中心</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">公示公告</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">招标信息</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/product',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 3 ? 'active' : ''"><div class="tabwordwidth">品牌产品<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" :to="{path:'/product',query: {type: 0}}">苏酒系列</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" :to="{path:'/product',query: {type: 1}}">双沟珍宝坊系列</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" :to="{path:'/product',query: {type: 2}}">双沟系列</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" :to="{path:'/product',query: {type: 3}}">其他系列</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<div class="tabmod" :class="pageind1 == 4 ? 'active' : ''"><div class="tabwordwidth">核心优势<em></em></div></div>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">湿地生态</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">千年酒脉</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">匠心传承</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">品质为天</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">科技研发</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">国家荣誉</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/zhwl',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 5 ? 'active' : ''"><div class="tabwordwidth">智慧文旅<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">岁月双沟</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">科技双沟</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">醉美双沟</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">苏酒文化客厅</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">头排酒开窑节</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">封藏大典</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/shzr',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 6 ? 'active' : ''"><div class="tabwordwidth">社会责任<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">社会公益</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">员工风采</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">员工关怀</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">双沟赞助</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/yxfw',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 7 ? 'active' : ''"><div class="tabwordwidth">服务支持<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">营销网络</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">防伪查询</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">经营者信息</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">线上购买</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">投诉打假</router-link></div></li> 
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">用户反馈</router-link></div></li> 
							</ul>
						</div>
					</router-link>
					<router-link class="navtab" to="/">
						<router-link class="nav-link" :to="{path:'/joinus',query: {type: 0}}"><div class="tabmod" :class="pageind1 == 8 ? 'active' : ''"><div class="tabwordwidth">加入我们<em></em></div></div></router-link>
						<div class="tabnextlist container">
							<ul class="nav-grp">
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">人才招聘</router-link></div></li>
								<li class="nav-item"><div class="nav-tit"><router-link class="nav-link" to="/">招商加盟</router-link></div></li> 
							</ul>
						</div>
					</router-link> -->
				</div>
			</div>
		</div>
		<div  v-else class="headerbox_m">
			<div class="headerlist_m">
				<img class="logo" src="../assets/images/logo.png" alt="双沟酒业"/>
				<div class="btn-menu " :class="{open:tabtype}" @click="showtab" id="toggleMenu">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
			<div class="tablist_m" :class="{opentab:tabtype}">
				<router-link to="/"><div class="tabmod_m">首页</div></router-link>
				<router-link v-for="(item,index) in catelist" :key="index" class="navtab" :to="{path:item.linkContent,query: {type: '',index:index}}"><div class="tabmod_m">{{item.title}}</div></router-link>
				<!-- <div class="tabmod_m">动态资讯</div>
				<div class="tabmod_m">品牌产品</div>
				<div class="tabmod_m">核心优势</div>
				<div class="tabmod_m">智慧文旅</div>
				<div class="tabmod_m">社会责任</div>
				<div class="tabmod_m">服务支持</div>
				<div class="tabmod_m">加入我们</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tyheader',
		props: {
			pageind: String,
		},
		data(){
			return{
				isshow:this.COMMON.isshow(),
				tabtype:false,
				pageind1:this.pageind,
				catelist:this.$store.getters.getcatelist,
			}
		},
		mounted() {
			let that=this
			window.onresize= (e) => {
				that.isshow = that.COMMON.isshow()
			}
			that.$axios.post('/w/menu').then(function (response) {
					if(response.data){
						that.$store.dispatch('getnewcatelist',response.data)
						// console.log(that.$store.getters.getcatelist)
					}else{
						that.$message({
							message: response.data.msg,
							type: 'warning'
						});
					}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			showtab(e){
				console.log(this.tabtype)
				this.tabtype = !this.tabtype
				console.log(this.tabtype)
			}
		}
	}
</script>

<style scoped>
	a{
		color: #ffffff;
		font-size: 18px;
	}
	.col333 a{color: #333333;}
	.headerbox,.headerbox_m{
		width: 100%;
		height: 80px;
		line-height: 80px;
		position: fixed;
		top: 0px;
		background-color: #ffffff;
		z-index: 9999999;
		border-bottom: 1px solid #eeeeee;
		
	}
	.headerlist{
		/* width: calc(100% - 520px); */
		max-width: 1400px;
		min-width: 1100px;
		height: 80px;
		line-height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #ffffff;
		margin: 0 auto;
	}
	.logo{
		width: 184px;
		height: 48px;
	}
	.tablist{
		width: 954px;
		display: flex;
		justify-content: space-around;
	}
	.tabmod{
		width: 110px;
		height: 80px;
		color: #333333;
		font-family: "syst";
		cursor: pointer;
		position: relative;
		display: flex;
		justify-content: center;
	}
	.tablist .tabmod em {
		position: absolute;
		left: 50%;
		bottom: 0;
		width: 0%;
		height: 2px;
		background: #119e7f;
		transition: 0.3s all;
		-webkit-transition: 0.3s all;
		-moz-transition: 0.3s all;
		-o-transition: 0.3s all;
		z-index: 9;
	}
	.tabwordwidth{position: relative;width: 72px;}
	.tablist .active em, .tablist .navtab:hover em{
    left: 0;
    width: 100%;
	}
	.tablist .active, .tablist .navtab:hover .tabmod{color: #119e7f;}
	
	.tabnextlist {
		position: absolute;
		left: 0;
		right: 0;
		top: 100%;
		background: #fff;
		font-size: 18px;
		overflow: hidden;
		background-color: rgba(0,0,0,0.3);
		display: none;
	}
	.nav-grp {
	  float: right;
	}
	.tabnextlist .nav-link {
		margin: 0 5px;
		padding: 0 30px;
		-webkit-transition: padding 0.2s;
		font-size: 16px;
		transition: padding 0.2s;
		color: #fff;
		font-family: "syst";
		background: url(../assets/images/yun.png) left no-repeat;
		-webkit-transition: .5s;
		-ms-transition: .5s;
		transition: .5s;
	}
	.tabnextlist:before {
	    content: '';
	    position: absolute;
	    left: 0;
	    right: 0;
	    top: 0;
	    height: 1px;
	    background-color: rgba(255,255,255,0.1);
	}
	.tablist>.navtab:hover .tabnextlist{display: block;}
	.tabnextlist .nav-link:hover{
		background-position:4px;
		-webkit-transition: .5s;
		-ms-transition:.5s;
		transition:.5s;
	}
	.nav-item {
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
		font-size: 18px;
		font-family: "syst";
	}
	.headerbox_m{height: 60px;}
	.headerbox_m .logo{width: 139px;height: 36px;}
	.headerlist_m{
		width: calc(100% - 100px);
		padding: 0px 50px;
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.headerlist_m .btn-menu {
	    float: right;
	    padding: 10px;
	    margin-top: 10px;
	}
	.headerlist_m .btn-menu span {
		display: block;
		width: 20px;
		height: 2px;
		background-color: #12344d;
		-o-transition: all 0.3s ease;
		transition: all 0.3s ease;
		-webkit-transition: all 0.3s ease;
		-ms-transform-origin: 20px;
		transform-origin: 20px;
		-webkit-transform-origin: 20px;
		margin-bottom: 5px;
	}
	.headerlist_m .btn-menu.open span:nth-child(1) {
	  transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
	  -ms-transform: rotate(-45deg);
	}
	.headerlist_m .btn-menu.open span:nth-child(2) {
		width: 0;
		opacity: 0;
	}
	.headerlist_m .btn-menu.open span:nth-child(3) {
		transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
	}
	.tablist_m{
		background-color: #119e7f;
		height: 0px;
		overflow: hidden;
		-o-transition: all 0.3s ease;
		transition: all 0.3s ease;
		-webkit-transition: all 0.3s ease;
	}
	.opentab{
		height: 513px;
	}
	.tabmod_m{
		padding: 15px 10px;
		height: 26px;
		line-height: 26px;
		text-align: left;
		border-bottom: 1px solid #ee8589;
		cursor: pointer;
		font-size: 18px;
		font-family: "syst";
		color: #ffffff;
	}
</style>
